import eighties from "./eighties.jpg";
import sweep from "./sweep.jpg";

const masks = {
  eighties,
  sweep,
};

export default masks;
